import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'
import { isWeixin, setRedirect, isIos } from '@/utils/index'
import { wxShare } from '@/utils/wx'

const whiteList = ['/login', '/author']
const authList = ['/login', '/author']

router.beforeEach(async (to, from, next) => {
  if (to.name === 'clazz') {
    const fromUser = to.query.f
    const shareClazz = to.params.clazz_id
    store.dispatch('SetClazzShare', { user: fromUser, clazz: shareClazz })
  }

  if (!store.getters.wxjsurl) {
    store.commit('SET_WX_JS_URL', document.URL)
  }

  if (getToken()) {
    if (authList.indexOf(to.path) !== -1) {
      next({ path: '/' })
    } else {
      if (store.getters.username) {
        next()
      } else {
        await store.dispatch('GetUserInfo')
        next({ ...to, replace: true })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.meta.noAuth) {
      next()
    } else {
      if (isWeixin()) {
        setRedirect(to.path)
        next(`/author?redirect=${to.path}`)
      } else {
        // next(`/login?redirect=${to.path}`)
        next(`/author?redirect=${to.path}`)
      }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!isWeixin()) return

  wxShare()

  // if (isIos) {
  //   jsUrl = encodeURIComponent(store.getters.wxjsurl.split('#')[0])
  // } else {
  //   jsUrl = encodeURIComponent(location.href.split('#')[0])
  // }

  // let response = await getWxConfig(jsUrl)
  // wx.config({
  //   debug: true,
  //   appId: response.data.appId,
  //   timestamp: response.data.timestamp,
  //   nonceStr: response.data.nonceStr,
  //   signature: response.data.signature,
  //   jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
  // })
})
